
export interface IUser {
    id: number;
    name: string;
}
export abstract class UserDataServiceInterface {
    abstract getUser(): Promise<IUser>;
    abstract setUser(userData:IUser): Promise<IUser>;
}
